import { TabsProps } from '@mui/material'
import { FC, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PaymentProvider } from '../../third-party/PaymentProvider'
import { Button } from '../Button'
import { Form, FormProps } from '../Form'
import {
  BankAccountFields,
  BankAccountFieldsProps,
} from '../SignModals/BankAccountFields'
import {
  CreditCardFields,
  CreditCardFieldsProps,
} from '../SignModals/CreditCardFields'
import { StyledTab, StyledTabs } from '../styled'

const PaymentMethodForm: FC<PaymentMethodFormProps> = ({
  lastName,
  action = 'Save',
  pending = false,
  tcElement,
  id,
  onSubmit,
  ...passingProps
}) => {
  const { payment } = passingProps

  const { t } = useTranslation()

  const [type, setType] = useState('card')

  const handleTypeChange: Required<TabsProps>['onChange'] = useCallback(
    (e, value) => {
      setType(value)
    },
    []
  )

  const handleSubmit = useCallback(() => {
    // Trigger payment manually.
    document.getElementById(PaymentProvider.formIds.SUBMIT_BUTTON)?.click()
    onSubmit?.()
  }, [onSubmit])

  return (
    <Form id={id} onSubmit={handleSubmit}>
      <StyledTabs value={type} onChange={handleTypeChange}>
        <StyledTab label={t('Credit card')} value="card" />
        <StyledTab label={t('Bank details')} value="bank" />
      </StyledTabs>
      {type === 'card' ? (
        <CreditCardFields {...passingProps} />
      ) : type === 'bank' ? (
        <BankAccountFields {...passingProps} />
      ) : undefined}
      {tcElement}
      <input
        type="hidden"
        value={lastName}
        id={PaymentProvider.formIds.CUSTOMER_LAST_NAME}
      />
      <input
        type="hidden"
        value={payment.customer_reference}
        id={PaymentProvider.formIds.CUSTOMER_REFERENCE}
      />
      {!id && (
        <Button type="submit" block pending={pending}>
          {action}
        </Button>
      )}
      <button
        type="button"
        hidden
        id={PaymentProvider.formIds.SUBMIT_BUTTON}
      ></button>
    </Form>
  )
}

type PaymentMethodFormProps = {
  lastName: string
  action?: string
  pending?: boolean
  tcElement?: React.ReactNode
  onSubmit?: VoidFunction
} & Pick<FormProps, 'id'> &
  Pick<Dto.Checkout, 'payment'> &
  (CreditCardFieldsProps | BankAccountFieldsProps)

export { PaymentMethodForm }
export type { PaymentMethodFormProps }
